export function VoterBadge({voter, onEdit}) {
  if (!voter) return null;

  // Build breadcrumb: flag Country > State > LGA
  const parts = [voter.country, voter.state, voter.lga].filter(Boolean);
  const label = parts.join(" › ");

  return (
    <button onClick={onEdit} title="Edit location" style={{display:"inline-flex",alignItems:"center",gap:6,background:"#0d1724",border:"1px solid #1e2d45",borderRadius:8,padding:"5px 10px",fontSize:12,color:"#64748b",cursor:"pointer",fontFamily:"inherit"}}>
      <span style={{fontSize:14}}>{voter.flag}</span>
      <span style={{color:"#94a3b8",maxWidth:160,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{label}</span>
      <span style={{color:"#475569",fontSize:9}}>✎</span>
    </button>
  );
}

export default VoterBadge;
